exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style_header__MlSQ_ {\n  background: rgb(239, 239, 239);\n  height: 80px;\n  margin: 0;\n}\n\n.style_container__3TbXE {\n  height: auto;\n  width: auto;\n  padding-top: 18px;\n  padding-left: 10px;\n}\n\n.style_title__dZdD7 {\n  color: #58666C;\n  line-height: 25px;\n  font-size: 2em;\n  font-weight: 600;\n}\n\n.style_description__-_ppP {\n  color: #58666C;\n  font-size: 1.4rem;\n  margin-left: 1px;\n  font-weight: 300;\n}\n\n.style_shadowBox__2Met0 {\n  box-shadow: 2px 1px 5px 0px rgb(99, 100, 100);\n}", ""]);

// Exports
exports.locals = {
	"header": "style_header__MlSQ_",
	"container": "style_container__3TbXE",
	"title": "style_title__dZdD7",
	"description": "style_description__-_ppP",
	"shadowBox": "style_shadowBox__2Met0"
};